import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import Modal from '../../../../../../../components/Modal';
import SegmentTrackingProvider from '../../../../../../../providers/SegmentTrackingProvider';
import PaymentMethodOptions from '../PaymentMethodOptions';

const PaymentMethodOptionsModal = ({
  open,
  onAdded,
  onClose,
  preferredFor,
}) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [hidden, setHidden] = useState(null);

  const modalSize = useMemo(() => {
    if (selectedOption === null) return 'extra-large';
    return 'extra-small';
  }, [selectedOption]);

  const onBeforeClose = useCallback(() => {
    setSelectedOption(null);
    onClose();
  }, []);

  const onPlaidFlowLoaded = useCallback(() => {
    setHidden(true);
  }, []);

  const onPlaidFlowClosed = useCallback(() => {
    setHidden(false);
  }, []);

  const onAfterAdded = useCallback((pm) => {
    if (onAdded) {
      onAdded(pm, onBeforeClose);
    } else {
      onBeforeClose();
    }
  }, []);

  useEffect(() => {
    if (selectedOption === null) {
      setHidden(false);
    }
  }, [selectedOption]);

  return (
    <Modal
      id="payment-method-options"
      size={modalSize}
      open={open}
      onClose={onBeforeClose}
      showCloseIcon
      disableOutsideClick
      mobileFullScreen
      visuallyHidden={hidden}
    >
      <Modal.Content noFooter noHeader>
        <SegmentTrackingProvider mapper={{}}>
          <PaymentMethodOptions
            onPlaidFlowLoaded={onPlaidFlowLoaded}
            onPlaidFlowClosed={onPlaidFlowClosed}
            onAdded={onAfterAdded}
            onSelection={setSelectedOption}
            onBankAccountFailed={onBeforeClose}
            preferredFor={preferredFor}
          />
        </SegmentTrackingProvider>
      </Modal.Content>
    </Modal>
  );
};

PaymentMethodOptionsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAdded: PropTypes.func,
  preferredFor: PropTypes.oneOf([
    'auto_pay',
    'rent_reporting',
    'rent_payments',
  ]),
};

export default PaymentMethodOptionsModal;
